module.exports = __webpack_public_path__ + "img/activelearnupskill.c37ac38d.svg";